export default __webpack_public_path__ + "media/f362c51b1321ba114d82bc68daef19a2.png";